export const STORE_SOCKET_INSTANCE_ACTION = 'storeSocketInstance'

export function storeSocketInstance(socket) {
    return { type: STORE_SOCKET_INSTANCE_ACTION, socket }
}
